var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResidentialinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.084 12.917H12.917a.416.416 0 01-.325-.677l1.416-1.77a1.242 1.242 0 01.976-.47h10.033a1.242 1.242 0 01.975.47l1.417 1.77a.416.416 0 01-.325.677z",
    fill: "#0F0449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.917 14.167h14.166a.417.417 0 01.417.416V28.75A1.25 1.25 0 0126.25 30h-4.167a.416.416 0 01-.416-.417v-1.666a1.667 1.667 0 00-3.334 0v1.666a.417.417 0 01-.416.417H13.75a1.25 1.25 0 01-1.25-1.25V14.583a.417.417 0 01.417-.416zm3.628 9.878a.417.417 0 00.122-.295v-1.667a1.25 1.25 0 00-2.5 0v1.667a.417.417 0 00.416.417h1.667c.11 0 .216-.044.295-.122zm0-5a.417.417 0 00.122-.295v-1.667a1.25 1.25 0 00-2.5 0v1.667a.417.417 0 00.416.417h1.667c.11 0 .216-.044.295-.122zm4.583 5a.417.417 0 00.122-.295v-1.667a1.25 1.25 0 00-2.5 0v1.667a.417.417 0 00.417.417h1.666c.11 0 .217-.044.295-.122zm0-5a.417.417 0 00.122-.295v-1.667a1.25 1.25 0 00-2.5 0v1.667a.417.417 0 00.417.417h1.666c.11 0 .217-.044.295-.122zm4.583 5a.417.417 0 00.122-.295v-1.667a1.25 1.25 0 00-2.5 0v1.667a.417.417 0 00.417.417h1.667c.11 0 .216-.044.294-.122zm0-5a.417.417 0 00.122-.295v-1.667a1.25 1.25 0 00-2.5 0v1.667a.417.417 0 00.417.417h1.667c.11 0 .216-.044.294-.122z",
    fill: "#0F0449"
  })));
}

export default SvgResidentialinline;